import type {
  EarningsResponse,
  NewsResponse,
  StockSymbol,
  WatchlistResponse,
} from "./types";

async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });
  const body = (await response.json()) as T & { message?: string };
  if (!response.ok) {
    const error = new Error(
      response.status === 401
        ? "Bitte erneut anmelden."
        : response.status === 429
          ? "Kursdienst-Limit erreicht. Bitte kurz warten."
          : "Aktiendaten konnten nicht geladen werden.",
    ) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  return body;
}

export function loadWatchlist(): Promise<WatchlistResponse> {
  return getJson<WatchlistResponse>("/api/stocks/watchlist");
}

export function loadNews(symbol: StockSymbol): Promise<NewsResponse> {
  return getJson<NewsResponse>(`/api/stocks/${symbol}/news`);
}

export function loadEarnings(symbol: StockSymbol): Promise<EarningsResponse> {
  return getJson<EarningsResponse>(`/api/stocks/${symbol}/earnings`);
}

export function formatMoney(value: number): string {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDate(timestamp: number): string {
  return new Date(timestamp * 1000).toLocaleString("de-DE");
}

export function quoteIsStale(timestamp: number): boolean {
  return Date.now() - timestamp * 1000 > 10 * 60 * 1000;
}
